import { createApi } from '@reduxjs/toolkit/dist/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { axiosProcedureQuery } from 'clickNgo/helpers/api'

import { IFinSobData, IGetPlanFinancialsParams } from '../model/types'

export const PLAN_FINANCIALS_TAG = 'PlanFinancials'

export const buildGetPlanFinancialsRequestData = ({
  partnerId,
  fYear,
  programType,
  category,
  isRollUp,
  isByCategory,
  isBySubCategory,
}: IGetPlanFinancialsParams) => {
  return {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.Offering': programType,
    'p.IsRollUp': isRollUp ? 1 : 0,
    'p.ByCategory': isByCategory ? 1 : 0,
    ...(isBySubCategory ? { 'p.BySubCategory': 1 } : {}),
    ...(category ? { 'p.Category': category } : {}),
  }
}

export const planFinancialsApi = createApi({
  reducerPath: `${FeatureType.P360Api}/planFinancialsApi`,
  baseQuery: axiosProcedureQuery<IFinSobData[]>(),
  tagTypes: [PLAN_FINANCIALS_TAG],
  endpoints(build) {
    return {
      getPlanFinancials: build.query<IFinSobData[], IGetPlanFinancialsParams>({
        query(params) {
          return {
            url: '/webservice/197/sp/v4/spJBPPartnerFinSobData/call',
            method: 'POST',
            data: buildGetPlanFinancialsRequestData(params),
          }
        },

        transformResponse(response: { Data?: IFinSobData[] } | undefined) {
          return Array.isArray(response?.Data) ? (response?.Data ?? []) : []
        },

        providesTags: (_result, _error, arg) => [
          {
            type: PLAN_FINANCIALS_TAG,
            id: `${arg.partnerId}::${arg.fYear}::${arg.programType?.trim() ?? ''}::${arg.category ?? ''}::${Number(arg.isRollUp)}::${Number(!!arg.isBySubCategory)}`,
          },
        ],
      }),
    }
  },
})

export const { useGetPlanFinancialsQuery } = planFinancialsApi
